import { Link, useRouterState } from "@tanstack/react-router";
import { CATEGORIES, calculatorsByCategory } from "@/lib/calculators";
import { useT } from "@/lib/i18n";

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { t, lang } = useT();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <nav className="space-y-6">
      {CATEGORIES.map((cat) => {
        const items = calculatorsByCategory(cat.id);
        return (
          <div key={cat.id}>
            <div className={`mb-2 flex items-center gap-2 px-2 text-xs font-bold uppercase tracking-wide text-muted-foreground ${lang === "bn" ? "font-bn" : ""}`}>
              <span className="text-base">{cat.emoji}</span>
              <span>{t(`categories.${cat.id}`)}</span>
            </div>
            <ul className="space-y-0.5">
              {items.map((c) => {
                const href = `/${c.slug}`;
                const active = pathname === href;
                return (
                  <li key={c.slug}>
                    <Link
                      to="/$slug"
                      params={{ slug: c.slug }}
                      onClick={onNavigate}
                      className={`block rounded-md px-2 py-1.5 text-sm transition ${
                        active
                          ? "bg-accent/10 text-accent font-semibold"
                          : "text-foreground/80 hover:bg-sidebar-accent hover:text-foreground"
                      } ${lang === "bn" ? "font-bn" : ""}`}
                    >
                      {c.name[lang]}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </nav>
  );
}
